import React, { useState } from "react";
import { useTranslation } from "react-i18next";
export default function ForumSearchBar({
    keyword = "",
    onSearch,
    onAdd
}) {
 const { t } = useTranslation();
    const [value, setValue] = useState(keyword);

    //------------------------------------------------------

    const handleSubmit = (e) => {
        e.preventDefault();
        if (onSearch) {
            onSearch(value.trim());
        }
    };

    //------------------------------------------------------

    const handleReset = () => {
        setValue("");
        if (onSearch) {
            onSearch("");
        }
    };

    //------------------------------------------------------

    return (
        <div className="card shadow-sm border-0 mb-4">
            <div className="card-body">
                <form
                    onSubmit={handleSubmit}
                >
                    <div className="row g-3 align-items-end">
                        <div className="col-lg-8">
                            <label className="form-label fw-semibold">
                                 {t("forum.newTopic")}
                            </label>

                            <div className="input-group">

                                <span className="input-group-text bg-white">

                                    <i className="bi bi-search text-success"></i>

                                </span>

                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder=  {t("forum.searchPlaceholder")}
                                    value={value}
                                    onChange={(e) =>
                                        setValue(e.target.value)
                                    }

                                />

                            </div>

                        </div>

                        {/*========================================*/}
                        {/* Boutons                                */}
                        {/*========================================*/}

                        <div className="col-lg-4">
                            <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                <button
                                    type="submit"
                                    className="btn btn-success"
                                >
                                    <i className="bi bi-search me-2"></i>
                                      {t("forum.search")}
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary"
                                    onClick={handleReset}
                                >
                                    <i className="bi bi-arrow-clockwise me-2"></i>
                                    {t("forum.reset")}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>

    );

}